import { req } from '../../@api/request';

export default class MainService {
  static main = async () => {
    const result = await req.get('/main');
    return result.data;
  };
  static youtube = async (name: string) => {
    const result = await req.get(`/youtube?channel=${name}`);
    return result.data;
  };
  static news = async () => {
    const result = await req.get('/news');
    return result.data;
  };
}
